/**
 * @generated SignedSource<<136b452f777774cbf4d425d3ee5c49e6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewLayoutMultiUser_IssueViewMultiUser$data = {
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutMultiUserField_IssueViewMultiUserField" | "ui_issueViewLayoutRequestParticipantsField_IssueViewRequestParticipantsField">;
  readonly " $fragmentType": "ui_issueViewLayoutMultiUser_IssueViewMultiUser";
};
export type ui_issueViewLayoutMultiUser_IssueViewMultiUser$key = {
  readonly " $data"?: ui_issueViewLayoutMultiUser_IssueViewMultiUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutMultiUser_IssueViewMultiUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrequestparticipantsrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "ui_issueViewLayoutMultiUser_IssueViewMultiUser",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutMultiUserField_IssueViewMultiUserField"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrequestparticipantsrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutRequestParticipantsField_IssueViewRequestParticipantsField"
        }
      ]
    }
  ],
  "type": "JiraMultipleSelectUserPickerField"
};

(node as any).hash = "7ed7bd6c74df473437eccce986c09224";

export default node;
